import React, { Component } from "react";
import __ from "lodash";
import { connect } from "react-redux";
import { cekCookies } from "../../../../actions";
import { CONFIG, URL_AKM } from "../../../../config";
import { metadataApi as akmApi } from "../../../../apis/indicatorApi";
import { unwrap, apiMessage, readableText, detailValidation } from "./indicatorWorkflow";
import LoaderModal from "../../../modal/LoaderModal";
import DropdownKelas from "../masterDropDown/DropdownKelas";
import DropdownMapel from "../masterDropDown/DropdownMapel";
import DropdownIndikator from "../masterDropDown/DropdownIndikator";
import DropdownUploadHistory from "../masterDropDown/DropdownUploadHistory";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Row, Col, Alert } from "react-bootstrap";
import { appendScript } from "../utils/appendScript";
import "./soalStyle.css";
import SoalMc from "./SoalMc";
import SoalMcc from "./SoalMcc";
import SoalBenarSalah from "./SoalBenarSalah";
import SoalEssay from "./SoalEssay";
import SoalDragDrop from "./SoalDragDrop";
import DropdownUploadHistoryAsync from "./DropdownUploadHistoryAsync";

class AddSoal extends Component {
  constructor(props) {
    super(props);
    const locationState = (props.location && props.location.state) || {};
    const soal = locationState.soal || {};
    const params = { idKelas: null, idMataPelajaran: null, idUploadHistory: null, tipeSoal: null, ...(locationState.params || {}) };
    this.state = {
      listKelas: [],
      listMapel: [],
      listTipeSoal: [],
      listIndikator: [],
      uploadHis: [],
      soal: { ...params, ...soal },
      filterSoalSearch: params,
      isFetching: false,
      alertShow: false,
      resMessage: "",
      action: "add",
      soalDetailAkm: [],
      metadataLoading: !!soal.idBankSoal,
      metadataFailed: false,
      locked: false,
      revisionReason: "",
    };
  }

  mounted = false;
  mapelRequest = 0;
  indicatorRequest = 0;

  async componentDidMount() {
    this.mounted = true;
    appendScript("/tinymceinit.js");
    this.setState({ isFetching: true });
    await this.props.cekCookies();    
    if (!__.isEmpty(this.props.account)) {
      const requests = [this.fetchKelas(), this.fetchTipeSoal(), this.fetchUploadHis()];
      if (this.state.filterSoalSearch.idKelas !== null) {
        requests.push(this.fetchMapel(this.state.soal.idKelas));
      }
      if (this.state.filterSoalSearch.idMataPelajaran !== null) {
        requests.push(this.fetchIndikator(this.state.soal.idKelas, this.state.soal.idMataPelajaran));
      }
      if (this.state.soal.idBankSoal) {
        this.setState({ action: "edit" });
      }

      if (this.state.soal.idBankSoal) requests.push(this.fetchMetadata());
      await Promise.all(requests);
    }

    this.setState({ isFetching: false });
  }

  componentWillUnmount() { this.mounted = false; this.mapelRequest += 1; this.indicatorRequest += 1; }

  fetchMetadata = async () => {
    this.setState({ metadataLoading: true, metadataFailed: false });
    try {
      const data = unwrap(await akmApi.get("/soal/metadata", { params: { idBankSoal: this.state.soal.idBankSoal } }));
      const row = data.rows && data.rows.find(item => String(item.idBankSoal) === String(this.state.soal.idBankSoal));
      if (!row) throw new Error("Missing metadata");
      if (this.mounted) this.setState({ locked: !!row.locked, soal: { ...this.state.soal, version: row.version } });
    } catch (error) { if (this.mounted) this.setState({ metadataFailed: true, alertShow: true, resMessage: apiMessage(error) }); }
    finally { if (this.mounted) this.setState({ metadataLoading: false }); }
  };

  createRevision = async () => {
    if (!this.state.locked || this.state.revisionReason.trim().length < 5 || this.state.isFetching) return;
    this.setState({ isFetching: true, alertShow: false });
    try {
      const data = unwrap(await akmApi.post("/soal/revision", { idBankSoal: this.state.soal.idBankSoal, reason: this.state.revisionReason.trim() }));
      if (!data || !data.bankSoal || !data.idBankSoal) throw new Error("Missing revision");
      const soal = data.bankSoal;
      this.props.history.replace({ pathname: "/addsoal", state: { ...(this.props.location.state || {}), soal, params: { ...this.state.filterSoalSearch, idBankSoal: soal.idBankSoal, idKelas: soal.idKelas, idMataPelajaran: soal.idMataPelajaran, tipeSoal: soal.tipeSoal, idUploadHistory: soal.idUploadHistory } } });
      window.location.reload();
    } catch (error) { if (this.mounted) this.setState({ isFetching: false, alertShow: true, resMessage: apiMessage(error) }); }
  };

  fetchKelas = async () => {
    this.setState({ alertShow: false });
    const response = await akmApi.get(URL_AKM.KELAS_ALL).catch((error) => {
      this.setState({ alertShow: true, resMessage: apiMessage(error) });
    });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listKelas: response.data.data,
        });
      } else {
        this.setState({
          listKelas: [],
          alertShow: true,
          resMessage: "Kelas " + response.data.errorSchema.errorMessage,
        });
      }
    }
  };

  fetchMapel = async (idKelas) => {
    const request = ++this.mapelRequest;
    this.setState({ alertShow: false });
    const response = await akmApi.get(URL_AKM.MAPEL_GET_BY_IDKELAS + idKelas).catch((error) => {
      this.setState({ alertShow: true, resMessage: apiMessage(error) });
    });
    if (response && this.mounted && request === this.mapelRequest) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listMapel: response.data.data,
        });
      } else {
        this.setState({
          listMapel: [],
          alertShow: true,
          resMessage: "Mapel " + response.data.errorSchema.errorMessage,
        });
      }
    }
  };

  fetchTipeSoal = async () => {
    const response = await akmApi.get(URL_AKM.GET_TIPE_SOAL).catch((error) => {
      this.setState({ alertShow: true, resMessage: apiMessage(error) });
    });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listTipeSoal: response.data.data,
        });
      } else {
        this.setState({
          listTipeSoal: [],
          alertShow: true,
          resMessage: response.data.errorSchema.errorMessage,
        });
      }
    }
  };

  fetchIndikator = async (idKelas, idMapel) => {
    const request = ++this.indicatorRequest;
    this.setState({ alertShow: false });
    const response = await akmApi
      .get(URL_AKM.GET_INDIKATOR, {
        params: { idKelas: idKelas, idMataPelajaran: idMapel },
      })
      .catch((error) => {
        this.setState({ alertShow: true, resMessage: apiMessage(error) });
      });
    if (response && this.mounted && request === this.indicatorRequest) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listIndikator: response.data.data.filter(item => !item.reviewStatus || item.reviewStatus === "APPROVED"),
        });
      } else {
        this.setState({
          listIndikator: [],
          alertShow: true,
          resMessage: "Indikator " + response.data.errorSchema.errorMessage,
        });
      }
    }
  };

  async fetchUploadHis() {
    const result = await akmApi.post(URL_AKM.POST_UPLOAD_HISTORY_ID, { idAdmin: this.props.account.idAdmin }).catch((error) => {
      console.log(error);
    });

    if (result) {
      let uploadHistory = [];
      if (result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        uploadHistory = result.data.data;
      }
      this.setState({ uploadHis: uploadHistory });
    }
  }

  handleChangeKelas = (event) => {
    const { value } = event.target;
    this.mapelRequest += 1;
    this.indicatorRequest += 1;
    this.setState({ soal: { ...this.state.soal, idKelas: value || null, idMataPelajaran: null, idIndikator: null }, listMapel: [], listIndikator: [] });
    if (value === "") {
      return;
    } else {
      this.fetchMapel(value);
    }
  };
  handleChangeMapel = (event) => {
    const { value } = event.target;
    this.indicatorRequest += 1;
    this.setState({ soal: { ...this.state.soal, idMataPelajaran: value || null, idIndikator: null }, listIndikator: [] });
    if (value === "") {
      return;
    } else {
      this.fetchIndikator(this.state.soal.idKelas, value);
    }
  };
  handleChangeBobot = (event) => {
    const { value } = event.target;
    if (value === "") {
      this.setState({ soal: { ...this.state.soal, mudahSulit: null } });
    } else {
      this.setState({ soal: { ...this.state.soal, mudahSulit: value } });
    }
  };
  handleChangeIndikator = (event) => {
    const { value } = event.target;
    if (value === "") {
      this.setState({ soal: { ...this.state.soal, idIndikator: null } });
    } else {
      this.setState({ soal: { ...this.state.soal, idIndikator: value } });
    }
  };
  handleChangeUpHis = (id) => {
    // const { value } = event.target;
    if (id === "") {
      this.setState({ soal: { ...this.state.soal, idUploadHistory: null } });
    } else {
      this.setState({ soal: { ...this.state.soal, idUploadHistory: id } });
    }
  };

  handleChangeKunci = (value) => {
    this.setState({ soal: { ...this.state.soal, kunciJawaban: value.trim() } });
  };
  addSoalDetailAkm = (value) => {
    this.setState({ soalDetailAkm: value });
  };

  handleSubmit = async () => {
    const { filterSoalSearch } = this.state;
    if (this.state.isFetching || this.state.locked || this.state.metadataLoading || this.state.metadataFailed) return;
    if (!this.state.soal.idKelas || !this.state.soal.idMataPelajaran || !this.state.listIndikator.some(item => String(item.idIndikator) === String(this.state.soal.idIndikator))) {
      this.setState({ alertShow: true, resMessage: "Pilih kelas, mata pelajaran, dan indikator yang sesuai sebelum menyimpan." });
      return;
    }
    if (["BNS", "DRAG"].indexOf(this.state.soal.tipeSoal) >= 0) {
      const message = detailValidation(this.state.soal.tipeSoal, this.state.soalDetailAkm);
      if (message) { this.setState({ alertShow: true, resMessage: message }); return; }
    }
    if (this.state.soal.mudahSulit === undefined) {
      this.setState({ alertShow: true, resMessage: "Bobot Soal harus di isi... !!" });
      return false;
    }
    if (this.state.soal.tipeSoal === "MCC") {
      const check = this.state.soal.kunciJawaban;
      if (typeof check !== "string" || !check.trim()) {
        alert("Kunci Jawaban harus diisi...");
        return false;
      }
      const str = check.split(",").map(value => value.trim()).filter(Boolean);
      if (!str.length || str.some(value => !/^[1-5]$/.test(value)) || new Set(str).size !== str.length) {
        alert("Pilih sekurangnya satu jawaban yang benar; setiap pilihan cukup satu kali.");
        return false;
      }
    }
    if (!window.tinyMCE || !window.tinyMCE.get("pertanyaan") || !window.tinyMCE.get("pembahasan")) {
      this.setState({ alertShow: true, resMessage: "Editor belum siap. Tunggu sebentar atau muat ulang halaman." });
      return;
    }
    if (["MULTIPLE", "MCC", "DROPDOWN"].indexOf(filterSoalSearch.tipeSoal) >= 0 && ["jawab1", "jawab2", "jawab3", "jawab4", "jawab5"].some(id => !window.tinyMCE.get(id))) {
      this.setState({ alertShow: true, resMessage: "Editor jawaban belum siap. Tunggu sebentar atau muat ulang halaman." });
      return;
    }
    if (__.isEmpty(window.tinyMCE.get("pertanyaan").getContent())) {
      this.setState({ alertShow: true, resMessage: "Field pertanyaan harus di isi... !!" });
      window.tinyMCE.get("pertanyaan").focus();
      return false;
    }

    // console.log('soal detail akm e', this.state.soalDetailAkm)
    // this.submitDetailSoal(1);

    if (window.confirm("Konfirmasi Simpan ?")) {
      this.setState({ isFetching: true });
      let dataSend = { ...this.state.soal, pertanyaan: window.tinyMCE.get("pertanyaan").getContent(), isianJawaban: window.tinyMCE.get("pembahasan").getContent() };
      if (filterSoalSearch.tipeSoal === "MULTIPLE" || filterSoalSearch.tipeSoal === "MCC" || filterSoalSearch.tipeSoal === "DROPDOWN") {
        dataSend = {
          ...dataSend,
          jawab1: window.tinyMCE.get("jawab1").getContent() === "" ? null : window.tinyMCE.get("jawab1").getContent(),
          jawab2: window.tinyMCE.get("jawab2").getContent() === "" ? null : window.tinyMCE.get("jawab2").getContent(),
          jawab3: window.tinyMCE.get("jawab3").getContent() === "" ? null : window.tinyMCE.get("jawab3").getContent(),
          jawab4: window.tinyMCE.get("jawab4").getContent() === "" ? null : window.tinyMCE.get("jawab4").getContent(),
          jawab5: window.tinyMCE.get("jawab5").getContent() === "" ? null : window.tinyMCE.get("jawab5").getContent(),
        };
      }

      const res = await akmApi.post(URL_AKM.BANK_SOAL_POST, dataSend).catch(error => {
        this.setState({ isFetching: false, alertShow: true, resMessage: apiMessage(error) });
      });
      if (res) {
        if (res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
          if (filterSoalSearch.tipeSoal === "BNS" || filterSoalSearch.tipeSoal === "DRAG") {
            this.submitDetailSoal(res.data.data.idBankSoal);
          } else {
            this.props.history.push({
              pathname: "/soal_akm",
              state: { params: this.state.filterSoalSearch },
            });
          }
        } else {
          this.setState({
            isFetching: false,
            alertShow: true,
            resMessage: res.data.errorSchema.errorMessage,
          });
        }
      }
    }
  };

  submitDetailSoal = async (idBankSoal) => {
    this.setState({ isFetching: true });
    console.log(this.state);
    let arrays = [...this.state.soalDetailAkm];
    if (this.state.soal.tipeSoal === "DRAG") {
      arrays.map((obj) => {
        obj.idBankSoal = idBankSoal;
      });
    } else {
      arrays.map((obj) => {
        obj.idBankSoal = idBankSoal;
        obj.id = null;
      });
    }

    const response = await akmApi.post(URL_AKM.POST_SOAL_DETAIL_AKM, arrays).catch((error) => {
      this.setState({ isFetching: false, alertShow: true, resMessage: apiMessage(error) });
    });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.props.history.push({
          pathname: "/soal_akm",
          state: { params: this.state.filterSoalSearch },
        });
      } else {
        this.setState({ isFetching: false, alertShow: true, resMessage: response.data.errorSchema.errorMessage });
      }
    }
  };

  renderEditor() {
    const { filterSoalSearch } = this.state;
    if (filterSoalSearch.tipeSoal === "MULTIPLE" || filterSoalSearch.tipeSoal === "DROPDOWN") {
      return <SoalMc soal={this.state.soal} handleChange={this.handleChangeKunci} />;
    }
    if (filterSoalSearch.tipeSoal === "MCC") {
      return <SoalMcc soal={this.state.soal} handleChange={this.handleChangeKunci} />;
    }
    if (filterSoalSearch.tipeSoal === "ESSAY" || filterSoalSearch.tipeSoal === "ISIAN") {
      return <SoalEssay soal={this.state.soal} handleChange={this.handleChangeKunci} />;
    }
    if (filterSoalSearch.tipeSoal === "BNS") {
      return <SoalBenarSalah soal={this.state.soal} addSoalDetailAkm={this.addSoalDetailAkm} />;
    }
    if (filterSoalSearch.tipeSoal === "DRAG") {
      return <SoalDragDrop soal={this.state.soal} addSoalDetailAkm={this.addSoalDetailAkm} />;
    }
  }

  render() {
    const { soal, filterSoalSearch, action } = this.state;
    let title = "";
    if (action === "add") {
      title = "Tambah";
    } else if (action === "edit") {
      title = "Ubah";
    }
    return (
      <div className="containerFluid" style={{ paddingTop: "10px", paddingBottom: "50px" }}>
        <LoaderModal isFetching={this.state.isFetching} />

        <div className="text-center">
          <h5>
            {title} Soal - {filterSoalSearch.keterangan}
          </h5>
        </div>
        <fieldset disabled={this.state.locked || this.state.metadataLoading || this.state.metadataFailed || this.state.isFetching} style={{ border: 0, padding: 0 }}><Col sm={12}>
          {this.loadAlert()}
          <Row>
            <Col xs={12} sm={6} lg={3}>
              <div className="form-group">
                <select className="form-control" name="kelas" id="kelas" aria-label="Kelas" value={soal.idKelas || ""} onChange={this.handleChangeKelas.bind(this)}>
                  <option value="" disabled>
                    Pilih Kelas...
                  </option>
                  <DropdownKelas kelas={this.state.listKelas} />
                </select>
              </div>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <div className="form-group">
                <select className="form-control" name="mapel" id="mapel" aria-label="Mata pelajaran" value={soal.idMataPelajaran || ""} onChange={this.handleChangeMapel.bind(this)}>
                  <option value="" disabled>
                    Pilih Mapel...
                  </option>
                  <DropdownMapel mapel={this.state.listMapel} />
                </select>
              </div>
            </Col>

            <Col xs={12} sm={6} lg={3}>
              <div className="form-group">
                <select className="form-control" name="bobot" id="bobot" aria-label="Bobot soal" value={soal.mudahSulit || ""} onChange={this.handleChangeBobot}>
                  <option value="" disabled>
                    Pilih Bobot Soal...
                  </option>
                  <option value="5">Sangat Mudah</option>
                  <option value="1">Mudah</option>
                  <option value="2">Sedang</option>
                  <option value="3">Sulit</option>
                  <option value="4">Sangat Sulit</option>
                </select>
              </div>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <div className="form-group">
                <select className="form-control" name="indikator" id="indikator" aria-label="Indikator" value={soal.idIndikator || ""} onChange={this.handleChangeIndikator}>
                  <option value="" disabled>
                    Pilih Indikator...
                  </option>
                  <DropdownIndikator indi={this.state.listIndikator} />
                </select>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              {/* <div className="form-group">
                <select className="form-control" name="uphis" id="uphis" value={soal.idUploadHistory || ""} onChange={this.handleChangeUpHis}>
                  <option value="" disabled>
                    Pilih Upload History...
                  </option>
                  <DropdownUploadHistory uploadHis={this.state.uploadHis} />
                  
                </select>
              </div> */}
              <DropdownUploadHistoryAsync idAdmin={this.props.account.idAdmin} handleChangeUpHis={(idUploadHistory) => this.handleChangeUpHis(idUploadHistory)} />
            </Col>
          </Row>
        </Col></fieldset>

        {this.state.metadataLoading && <p role="status">Memeriksa penggunaan soal...</p>}
        {this.state.metadataFailed && <div role="alert"><p>Status penggunaan belum dapat diperiksa. Penyimpanan ditahan untuk menjaga laporan lama.</p><button type="button" className="btn btn-outline-secondary" onClick={this.fetchMetadata}>Periksa ulang</button></div>}
        {this.state.locked && <div className="alert alert-info" role="status"><strong>Soal sudah dipakai. Versi ini dilindungi.</strong><p>Buat revisi baru untuk memperbaiki isi atau indikator tanpa mengubah laporan lama.</p><label htmlFor="revision-reason">Alasan revisi</label><input id="revision-reason" className="form-control" value={this.state.revisionReason} maxLength="500" disabled={this.state.isFetching} onChange={event => this.setState({ revisionReason: event.target.value })} /><button type="button" className="btn btn-primary mt-2" disabled={this.state.isFetching || this.state.revisionReason.trim().length < 5} onClick={this.createRevision}>Buat revisi baru</button></div>}

        {this.state.locked ? <div className="card card-body">{readableText(soal.pertanyaan)}</div> : this.renderEditor()}

        {/* {filterSoalSearch.tipeSoal !== 'DRAG' &&  */}
        <div className="bottom-header-fixed">
          <Row>
            <Col sm={6}>
              <button className="btn btn-danger pull-left" onClick={() => this.handleBack()}>
                <ArrowBackIosIcon /> Kembali
              </button>
            </Col>
            <Col sm={6}>
              <button className="btn btn-primary pull-right" onClick={this.handleSubmit} disabled={this.state.isFetching || this.state.locked || this.state.metadataLoading || this.state.metadataFailed}>
                <SaveIcon /> Simpan
              </button>
            </Col>
          </Row>
        </div>
        {/* }          */}
      </div>
    );
  }

  handleBack() {
    
    if (window.confirm("Are You Sure... ??")) {
      
      this.props.history.push({
        pathname: (this.props.location.state && this.props.location.state.fromUrl) || "/soal_akm",
        state: { params: this.state.filterSoalSearch },
      });
    }
  }

  loadAlert = () => {
    const { alertShow } = this.state;

    if (alertShow) {
      return (
        <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>
          <strong>{this.state.resMessage}</strong>
        </Alert>
      );
    }
  };
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(AddSoal);
